import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

/**
 * Represents environments data

 * @interface Environments
 */
interface Environments {
    /**
     * The base URL for api
     */
    apiUrl: string
    /**
     * The base URL for documentation
     */
    documentationUrl: string
    /**
     * The running mode
     */
    production: boolean

    /**
     * The definition of min password length for password change
     * It is mandatory only to change the min password length 
     * Default value is 8
     */    
    minPasswordLength: number
    /**
     * Definition of the authentication type 
     * Default not defined or "" for Mua users
     * It is mandatory and should be set to "Local" only to enable password change for local users
     * - Undefined or empty string - for Mua users - default
     * - "Locale" - for local user authentication
     * - "0" - only for debug purposes
     */
    authenticationType: string,
}

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    /**
     * Instance of HttpClient for making HTTP requests.
     */
    http = inject(HttpClient)

    /**
     * Set url to environments json file
     */
    private configUrl = 'assets/environment/environment.json'

    constructor() {}

    /**
     * Load environment from json
     *
     * @returns {Observable<any>} An observable indicating the result of the operation trigger.
     *
     * Functionality:
     * - Sends a GET request to load json file.
     */
    loadEnvironments(): Observable<Environments> {
        const response = this.http.get<Environments>(this.configUrl)
        return response
    }
}
